/* eslint-disable array-callback-return */
import React from 'react';
import CardA1 from '../Cards/CardA1';
import CardA from '../Cards/CardA';
import "./SectionStyles/Sections.css";

const SectionA = (props) => {
  const CardTheme = [
    {
      value: 1,
    }
  ];
  // Id should be in strings so that when the size is selected the id of option and id of card can concatinate.
  const cardData = [
    {
      id: '1',
      name: "Creamy Supreme'o",
      discountedprice: '250',
      price: "400",
      img: "https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652261528-Crispy%20Chicken%20Burger.jpg&w=256&q=75",
      des: 'CheeseMughlai meat Onion Green paper Tomato Diced cut cucumber',
      percent: "10",
      quantity: "2",
    },
    {
      id: '2',
      name: "CardA 2",
      discountedprice: '150',
      price: "200",
      img: "https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652261528-Crispy%20Chicken%20Burger.jpg&w=256&q=75",
      des: 'CheeseMughlai meat Onion Green paper Tomato Diced cut cucumber',
      percent: "20",
    },
    {
      id: '3',
      name: "CardA 3",
      discountedprice: '300',
      price: "500",
      img: "https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652261528-Crispy%20Chicken%20Burger.jpg&w=256&q=75",
      des:'CheeseMughlai meat Onion Green paper Tomato Diced cut cucumber',
      percent: "30"
    },
    {
      id: '4',
      name: "CardA 4",
      discountedprice: '200',
      price: "350",
      img: "https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652261528-Crispy%20Chicken%20Burger.jpg&w=256&q=75",
      des: 'CheeseMughlai meat Onion Green paper Tomato Diced cut cucumber',
      percent: "40"
    }
  ];

  return (

    <>
      {CardTheme.map((theme) => {

        if (theme.value === 1) {
          return (
            <div id={props.id} key={theme.value} className='main-main'>
              <h1>{props.Heading}</h1>
              <div className='main'>
                {cardData.map((data, id) => (
                  <CardA 
                  
                    key={id}
                    id={data.id}
                    name={data.name}
                    discountedprice={data.discountedprice}
                    price={data.price}
                    img={data.img}
                    des={data.des}
                    percent={data.percent}
                    quantity={data.quantity}

                  />
                ))}
              </div>
            </div>
          )
        }
        else if (theme.value === 2) {
          return (
            <div id={props.id} key={theme.value} className='main-main'>
              <h1>{props.Heading}</h1>
              <div className='main'>
                {
                  cardData.map((data, id) => (
                    <CardA1
                      key={id}
                      id={data.id}
                      name={data.name}
                      discountedprice={data.discountedprice}
                      price={data.price}
                      img={data.img}
                      des={data.des}
                      percent={data.percent}
                      quantity={data.quantity}
                    />
                  ))
                }
              </div>
            </div>
          )
        }

      }
      )
      }
    </>
  );
};
SectionA.defaultProps = {
  Heading: "Section A",
  id:"sectionA"
}

export default SectionA;
